import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import AdmissionForm from "../components/AdmissionForm";
import AdmissionForm2 from "../components/AdmissionForm2";
import AdmissionForm3 from "../components/AdmissionForm3";
import AdmissionForm4 from "../components/AdmissionForm4";
import AdmissionForm6 from "../components/AdmissionForm6";
import CustomizedTabs from "../components/CommonTab";
import Spinner from "../components/Spinner";
import Acknowledgment from "../pages/Acknowledgment";
import CivilIdDocument from "../pages/CivilIdDocument";
import CivilNumberVerification from "../pages/CivilNumberVerification";
import EmailVerification from "../pages/EmailVerification";
import FinalPolicyPreview from "../pages/FinalPolicyPreview";
import FinalSubmissionPage from "../pages/FinalSubmissionPage";
import SubmitPage from "../pages/SubmitPage";
import SuccessPage from "../pages/SuccessPage";
import { BASE_URL, IS_TESTING } from "../utils/config";
import { initialFormData, getTestFormData } from "../utils/formData";
import { validateForm } from '../utils/validateForm';

function AdmissionFormPage() {
  // --------- ADMISSION TOGGLE ---------
  const isAdmissionsOpen = true; // <-- CHANGE TO true TO REOPEN ADMISSIONS
  // ------------------------------------

  const steps = [
    "PERSONAL",
    "FAMILY",
    "HEALTH",
    "ACADEMIC",
    "EMERGENCY",
    "DOCUMENT"
  ];

  const [step, setStep] = useState(-3);
  const [studentId, setStudentId] = useState(null);
  const [applicationId, setApplicationId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const loadFormData = () => {
    if (IS_TESTING) return getTestFormData();
    const stored = localStorage.getItem("FormData");
    if (!stored) return initialFormData;
    try {
      const parsed = JSON.parse(stored);
      if (parsed && parsed.document) {
        // Sanitize documents: any value that is not a real file object (or is `{}`) should be set back to null
        Object.keys(parsed.document).forEach(key => {
          const docVal = parsed.document[key]?.value;
          if (docVal && typeof docVal === "object" && !docVal.name) {
            parsed.document[key].value = null;
          }
        });
      }
      return parsed;
    } catch (e) {
      return initialFormData;
    }
  };

  const [formData, setFormData] = useState(loadFormData);
  const [showError, setShowError] = useState(false);
  const [documentError, setDocumentError] = useState(false);
  const [documentErrorMsg, setDocumentErrorMsg] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const handleKeyDown = (event) => {
      const key = event.key.toLowerCase();
      const isCtrlOrMeta = event.ctrlKey || event.metaKey;

      // Keep copy/cut restricted inside the application workflow.
      if (isCtrlOrMeta && (key === "c" || key === "x")) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    const blockAction = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    document.addEventListener("keydown", handleKeyDown, true);
    document.addEventListener("contextmenu", blockAction, true);
    document.addEventListener("copy", blockAction, true);
    document.addEventListener("cut", blockAction, true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
      document.removeEventListener("contextmenu", blockAction, true);
      document.removeEventListener("copy", blockAction, true);
      document.removeEventListener("cut", blockAction, true);
    };
  }, []);

  const handleChange = (e, firstKey, secondKey, thirdKey, forthKey) => {
    if (e.persist) e.persist();
    console.log(e);
    setFormData((currentData) => {
      let value;
      const { type } = e?.target || {};
      if (type === "text" && e.target.value) {
        value =
          e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
      } else {
        value = e?.target?.value;
      }

      console.log(value);

      const data = { ...currentData };
      let updateData = data;
      console.log(firstKey);

      if (firstKey) {
        if (!updateData[firstKey]) {
          updateData[firstKey] = {};
        }
        if (!secondKey) {
          updateData[firstKey].value = value;
          localStorage.setItem("FormData", JSON.stringify(data));
          return data;
        }
        updateData = updateData[firstKey];
      }

      if (secondKey) {
        if (!updateData[secondKey]) {
          updateData[secondKey] = {};
        }
        if (!thirdKey) {
          updateData[secondKey].value = value;
          localStorage.setItem("FormData", JSON.stringify(data));
          return data;
        }
        updateData = updateData[secondKey];
      }

      if (thirdKey) {
        if (!updateData[thirdKey]) {
          updateData[thirdKey] = {};
        }
        if (!forthKey) {
          updateData[thirdKey].value = value;
          localStorage.setItem("FormData", JSON.stringify(data));
          return data;
        }
        updateData = updateData[thirdKey];
      }

      if (forthKey) {
        if (!updateData[forthKey]) {
          updateData[forthKey] = {};
        }
        updateData[forthKey].value = value;
        localStorage.setItem("FormData", JSON.stringify(data));
        return data;
      }

      updateData.value = value;
      localStorage.setItem("FormData", JSON.stringify(data));
      return data;
    });
  };

  function cleanObject(obj) {
    if (Array.isArray(obj)) {
      return obj
        .map(cleanObject)
        .filter(item => item !== null && item !== '' && !(typeof item === 'object' && Object.keys(item).length === 0));
    } else if (typeof obj === 'object' && obj !== null) {
      const newObj = {};
      for (const key in obj) {
        const cleaned = cleanObject(obj[key]);
        if (
          cleaned !== null &&
          cleaned !== '' &&
          !(typeof cleaned === 'object' && Object.keys(cleaned).length === 0)
        ) {
          newObj[key] = cleaned;
        }
      }
      return newObj;
    } else {
      return obj;
    }
  }


  useEffect(() => {
    if (Object.keys(errors)?.length > 0) {
      setShowError(false);
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const areAllDocumentsUploaded = () => {
    if (IS_TESTING) return true;
    const isValidUploadedValue = (fileValue) => {
      if (!fileValue) {
        return false;
      }

      const isPdf = (val) => {
        if (typeof val === "string") {
          return val.toLowerCase().endsWith(".pdf");
        }
        if (typeof File !== "undefined" && val instanceof File) {
          return val.name.toLowerCase().endsWith(".pdf") || val.type === "application/pdf";
        }
        if (typeof Blob !== "undefined" && val instanceof Blob) {
          return val.type === "application/pdf";
        }
        if (typeof val === "object" && typeof val.name === "string") {
          return val.name.toLowerCase().endsWith(".pdf");
        }
        return false;
      };

      return isPdf(fileValue);
    };

    const requiredDocs = [
      "transcript",
      "englishscore",
      "birthCertificate",
      "civilidFront",
      "civilidBack",
      "passport",
      "photograph",
      "goodconduct",
      "fatherCivilId",
      "fatherPassport",
      "motherCivilId",
      "motherPassport"
    ];

    // Add conditional documents based on nationality
    if (formData.nationality.value === "Non Kuwaiti") {
      requiredDocs.push("securityCardFront", "securityCardBack");
    } else if (formData.nationality.value === "Kuwait") {
      requiredDocs.push("sahel");
    }

    // Check if all required documents have been uploaded
    const failedDocs = requiredDocs.filter(doc => {
      const isValid = isValidUploadedValue(formData.document?.[doc]?.value);
      console.log(`Document ${doc} validity:`, isValid, formData.document?.[doc]?.value);
      return !isValid;
    });

    if (failedDocs.length > 0) {
      console.log("Documents validation failed for keys:", failedDocs);
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step <= 6) {
      // Special handling for document step
      if (step === 5) {
        if (!areAllDocumentsUploaded()) {
          setDocumentError(true);
          setDocumentErrorMsg("Please upload all required documents before proceeding.");
          window.scrollTo(0, 0);
          return;
        } else {
          setDocumentError(false);
          setDocumentErrorMsg("");
          setStep(step + 1);
          window.scrollTo(0, 0);
          return;
        }
      }

      const isValid = validateForm(formData, setErrors, step);
      // const isValid = true;

      console.log(step, isValid);

      if (isValid) {
        setStep(step + 1);
        window.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
        setShowError(true);
        console.log(
          "Form has errors. Please fill in all required fields.",
          errors
        );
      }
    } else if (step === 7) {
      // From FinalPolicyPreview (confirmation page) -> go to FinalSubmissionPage (step 8)
      setStep(step + 1);
      window.scrollTo(0, 0);
    } else if (step === 8) {
      // From FinalSubmissionPage (submission instructions) -> submit form
      submitForm();
    }
  };

  const registerStudent = async () => {
    if (studentId) return studentId;

    let archivements = {};

    formData.archivements.value?.forEach((data, index) => {
      if (formData.archivements.value.length > 0) {
        archivements[index] = data.value;
      }
    });

    setIsLoading(true);

    try {
      const uploadData = {
        applicationType: "BDM",
        applicationYear: new Date().getFullYear(),

        firstName: formData.firstName.value,
        middleName: formData.middleName.value,
        lastName: formData.lastName.value,
        firstNameArabic: formData.arabicFirstName.value,
        middleNameArabic: formData.arabicMiddleName.value,
        lastNameArabic: formData.arabicLastName.value,
        dob: formData.dob.value,
        gender: formData.gender.value,
        maritalStatus: formData.maritalStatus.value,
        civilId: formData.civilId.value,

        nationality: formData.nationality.value,
        birthCountry: formData.birthCountry.value,
        passport: formData.passport.value,
        validityOfRes: formData.validityOfRes.value,
        securityCard: formData.securityCard.value,
        securityCardExpiry: formData.securityCardExpiry.value,
        civilIdExpiry: formData.validityOfRes.value,


        address: {
          home: formData.address.home.value,
          block: formData.address.block.value,
          street: formData.address.street.value,
          appartment: formData.address.appartment.value,
          area: formData.address.area.value,
          jaddah: formData.address.jaddah.value,
          country: formData.address.country.value,
          po: formData.address.po.value,
          zipCode: formData.address.zipCode.value,
          governorate: formData.address.governorate.value
        },


        // civilIdExpiry: formData.civilIdExpiryDate.value,
        mobileOne: formData.mobileOne.value,
        mobileTwo: formData.mobileTwo.value,
        homeTelOne: formData.homeTelOne.value,
        homeTelTwo: formData.homeTelTwo.value,
        workTelOne: formData.workTel.value,
        taxTel: formData.homeTelTwo.value,
        emailOne: formData.emailOne.value,

        family: {
          fatherName: formData.family.fatherName.value,
          fatherNameArabic: formData.family.arabicFatherName.value,
          fatherDob: formData.family.fatherDob.value,
          fatherNationality: formData.family.fatherNationality.value,
          fatherCivilId: formData.family.fatherCivilId.value,
          fatherOccup: formData.family.fatherOccup.value,
          fatherDepartment: formData.family.fatherDepartment.value,
          fatherEmployer: formData.family.fatherEmployer.value,
          fatherMobile: formData.family.fatherMobile.value,
          fatherWorkTel: formData.family.fatherWorkTel.value,
          fatherEmail: formData.family.fatherEmail.value,
          fatherExactJob: formData.family.fatherExactJob.value,

          motherName: formData.family.motherName.value,
          motherNameArabic: formData.family.arabicMotherName.value,
          motherDob: formData.family.motherDob.value,
          motherNationality: formData.family.motherNationality.value,
          motherCivilId: formData.family.motherCivilId.value,
          motherOccup: formData.family.motherOccup.value,
          motherDepartment: formData.family.motherDepartment.value,
          motherEmployer: formData.family.motherEmployer.value,
          motherMobile: formData.family.motherMobile.value,
          motherWorkTel: formData.family.motherWorkTel.value,
          motherEmail: formData.family.motherEmail.value,
          motherExactJob: formData.family.motherExactJob.value
        },

        sponsorship: Object.keys(formData.sponsorship.value || {})?.[0],
        sponsorshipOtherNote: formData.sponsorshipOtherNote.value,
        sponsorshipNote: formData.sponsorshipScholarshipNote.value,

        isHealthRecord: formData.isHealthRecord.value,
        healthNote: formData.healthNote.value,
        isSuspended: formData.isSuspended.value,
        suspensionNote: formData.suspensionNote.value,

        archivements: formData.isAcademic.value ? archivements : {},


        scientificSubject: {
          physics: formData.scientificMarks.value[0]?.physics?.value,
          chemistry: formData.scientificMarks.value[0]?.chemistry?.value,
          biology: formData.scientificMarks.value[0]?.biology?.value,
          average: formData.scientificMarks.value[0]?.average?.value
        },

        englishTest: {
          score: formData.test.testScore.value,
          date: formData.test.testDate.value,
          type: formData.test.testType.value,
          otherNote: formData.testTypeOtherNote.value
        },

        education: [
          ...formData.school.value?.map((data) => ({
            name: data.name.value,
            type: "school",
            gpa: data.gpa.value,
            date: data.date.value,
            degree: data.degree.value
          })),
          ...(formData.isCollege.value
            ? formData.college.value?.map((data) => ({
              name: data.name.value,
              type: "college",
              country: data.country.value,
              gpa: data.gpa.value,
              date: data.date.value,
              major: data.major.value,
              degree: data.degree.value
            }))
            : [])
        ],

        emergency: [
          {
            name: formData.emergency[0].name.value,
            contact: formData.emergency[0].contact.value,
            relationship: formData.emergency[0].relationship.value,
            civilId: formData.emergency[0].civilId.value
          },
          {
            name: formData.emergency[1].name.value,
            contact: formData.emergency[1].contact.value,
            relationship: formData.emergency[1].relationship.value,
            civilId: formData.emergency[1].civilId.value
          }
        ],
        relatives: formData.relatives.selected.value,
        relativesNote:
          formData.relatives.selected.value === "kuwait university" ||
            formData.relatives.selected.value === "mohe"
            ? formData.relativesNote.value
            : null,
        eligible: formData.eligible.value
      };

      const cleaned = cleanObject(uploadData);

      const response = await fetch(
        `${BASE_URL}/student/admission/application-one`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ ...cleaned })
        }
      );

      const result = await response.json();
      console.log("RESULT", result);

      if (result.status) {
        setStudentId(result.data.id);
        if (result.data.student?.applicationId) {
          setApplicationId(result.data.student.applicationId);
        }

        try {
          const docFile = new FormData();
          docFile.append("id", `${result.data.id}`);
          docFile.append("photograph", formData.document.photograph.value);
          docFile.append("transcript", formData.document.transcript.value);
          docFile.append("englishscore", formData.document.englishscore.value);
          docFile.append("highschool", formData.document.highschool.value);
          docFile.append("civilidFront", formData.document.civilidFront.value);
          docFile.append("civilidBack", formData.document.civilidBack.value);
          docFile.append("securityFront", formData.document.securityCardFront.value);
          docFile.append("securityBack", formData.document.securityCardBack.value);
          docFile.append("passport", formData.document.passport.value);
          docFile.append("record", formData.document.record.value);
          docFile.append("goodconduct", formData.document.goodconduct.value);
          docFile.append("fatherCivilId", formData.document.fatherCivilId.value);
          docFile.append("motherCivilId", formData.document.motherCivilId.value);
          docFile.append("sahel", formData.document.sahel.value);
          docFile.append("equivalency", formData.document.equivalency.value);
          docFile.append("birthCertificate", formData.document.birthCertificate.value);
          docFile.append("fatherPassport", formData.document.fatherPassport.value);
          docFile.append("motherPassport", formData.document.motherPassport.value);
          docFile.append("otherDocuments", formData.document.otherDocuments.value);
          
          for (let [key, value] of docFile.entries()) {
            if (value === null || value === undefined) {
              docFile.delete(key);
            }
          }
          await fetch(`${BASE_URL}/student/admission/document/`, {
            method: "POST",
            body: docFile
          });
        } catch (e) {
          console.error("Failed to pre-upload docs", e);
        }

        return result.data.id;
      } else {
        toast.error("Form registration failed!");
        return null;
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error("Form registration failed!", error);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const submitForm = async () => {
    let currentId = studentId;

    if (!currentId) {
      currentId = await registerStudent();
    }

    if (!currentId) {
      toast.error("Form submission failed: Application ID not found.");
      return;
    }

    setIsLoading(true);

    try {
      const docFile = new FormData();
      console.log("INITIALIZE", docFile);

      docFile.append("id", `${currentId}`);
      docFile.append("photograph", formData.document.photograph.value);
      docFile.append("transcript", formData.document.transcript.value);
      docFile.append("englishscore", formData.document.englishscore.value);
      docFile.append("highschool", formData.document.highschool.value);
      docFile.append("civilidFront", formData.document.civilidFront.value);
      docFile.append("civilidBack", formData.document.civilidBack.value);
      docFile.append("securityFront", formData.document.securityCardFront.value);
      docFile.append("securityBack", formData.document.securityCardBack.value);
      docFile.append("passport", formData.document.passport.value);
      docFile.append("record", formData.document.record.value);
      docFile.append("goodconduct", formData.document.goodconduct.value);
      docFile.append("fatherCivilId", formData.document.fatherCivilId.value);
      docFile.append("motherCivilId", formData.document.motherCivilId.value);
      docFile.append("sahel", formData.document.sahel.value);
      docFile.append("equivalency", formData.document.equivalency.value);
      docFile.append("birthCertificate", formData.document.birthCertificate.value);
      docFile.append("fatherPassport", formData.document.fatherPassport.value);
      docFile.append("motherPassport", formData.document.motherPassport.value);
      docFile.append("otherDocuments", formData.document.otherDocuments.value);

      let docFileLen = 0;
      for (const entry of docFile.entries()) {
        console.log(entry[0], entry[1]);
        docFileLen++;
      }
      const isFormDataEmpty = docFileLen === 0;
      console.log("Is FormData Empty:", isFormDataEmpty);

      if (isFormDataEmpty) {
        setStep(5);
      } else {
        try {
          for (let [key, value] of docFile.entries()) {
            if (value === null || value === undefined) {
              docFile.delete(key);
            }
          }

          const docResponse = await fetch(
            `${BASE_URL}/student/admission/document/`,
            {
              method: "POST",
              body: docFile
            }
          );

          const jsonDoc = await docResponse.json();
          console.log(jsonDoc);

          if (jsonDoc.status) {
            toast.success("Form submitted successfully!");
            localStorage.removeItem("FormData");
            setStep(9);
          } else {
            setStep(-3);
            setDocumentError(true);
            setDocumentErrorMsg(jsonDoc.message);
          }
        } catch (docError) {
          console.error("Document upload failed:", docError);
          setStep(-3);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Form submission failed!", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setStep(-3);
    localStorage.removeItem("otp");
    localStorage.removeItem("FormData");

    setFormData(initialFormData);
  };

  const getEmptyDocumentState = () => {
    const emptyDocuments = {};

    Object.keys(initialFormData.document).forEach((key) => {
      emptyDocuments[key] = { ...initialFormData.document[key] };
    });

    return emptyDocuments;
  };

  const handleBack = () => {
    const nextStep = step - 1 >= 0 ? step - 1 : 0;
    setStep(nextStep);
  };
  const stepHandler = () => {
    setStep(step + 1);
  };

  useEffect(() => {
    if (localStorage.getItem("FormData")) {
      setFormData({
        ...JSON.parse(localStorage.getItem("FormData")),
        document: formData.document
      });
    }
    return () => {
      localStorage.removeItem("otp");
    };
  }, [formData.document]);

  // CLOSED ADMISSIONS SCREEN
  if (!isAdmissionsOpen) {
    return (
      <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center p-6 font-sans">
        <div className="bg-white shadow-2xl rounded-3xl overflow-hidden max-w-lg w-full">
          <div className="h-4 bg-[#b60041]"></div>
          <div className="p-10 text-center">
            <div className="mb-6 inline-flex items-center justify-center w-20 h-20 bg-red-50 rounded-full">
              <svg className="w-10 h-10 text-[#b60041]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h1 className="text-4xl font-extrabold text-slate-800 mb-4 tracking-tight">Admissions Closed</h1>
            <div className="w-16 h-1 bg-[#b60041] mx-auto mb-6 rounded-full"></div>
            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              Thank you for your interest. <br/>
              <b>Admissions for the 2026/2027 Academic Year are currently closed.</b>
            </p>
            <p className="text-sm text-slate-400 italic bg-slate-50 py-3 rounded-lg border border-slate-100">
              Please check back later for updates.
            </p>
          </div>
          <div className="bg-slate-50 px-10 py-4 text-center border-t border-slate-100 italic text-slate-400 text-xs text-uppercase">
            AUMS • Academic Excellence
          </div>
        </div>
      </div>
    );
  }

  // ACTIVE ADMISSIONS WORKFLOW
  return (
    <div className="">
      {step >= 0 && step <= 7 ? (
        <div className="mx-4 mt-4 mb-2 rounded-md border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900">
          Copying is restricted on this application form.
        </div>
      ) : null}
      {
        step === -3 ?
          (
            <Acknowledgment stepHandler={stepHandler} />
          )
          :
          step === -2 ?
            (
              <CivilNumberVerification
                civilId={formData.civilId}
                handleChange={handleChange}
                stepHandler={stepHandler}
              />
            )
            :
            step === -1 ?
              (
                <EmailVerification
                  stepHandler={stepHandler}
                  email={formData.emailOne}
                  handleChange={handleChange}
                />
              )
              :
              step >= 0 && step <= 5 ?
                (
                  <>
                    <CustomizedTabs steps={steps} value={step} />
                    <form onSubmit={handleSubmit}>
                      {step === 0 ? (
                        <AdmissionForm
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 1 ? (
                        <AdmissionForm2
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 2 ? (
                        <AdmissionForm3
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 3 ? (
                        <AdmissionForm4
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 4 ? (
                        <AdmissionForm6
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) : step === 5 ? (
                        <CivilIdDocument
                          showError={showError}
                          documentError={documentError}
                          documentErrorMsg={documentErrorMsg}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                        />
                      ) :
                        null}
                      <Box style={{ height: "4rem" }}></Box>
                      <Box className="submitContainer border-t-[1px] border-t-[#b60041]">
                        <Button type="button" className={"cancelButton"} onClick={handleCancel}>
                          Cancel
                        </Button>
                        {step > 0 ? (
                          <Button type="button" className={"cancelButton"} onClick={handleBack}>
                            Back
                          </Button>
                        ) : null}
                        <Button
                          disabled={false}
                          className={"submitButton disabled:bg-red-100 "}
                          type="submit"
                        >
                          Next
                        </Button>
                      </Box>
                    </form>
                  </>
                )
                :
                step >= 6 ? (
                  <div className="submission-steps-container">
                    {step === 6 ? (
                      <>
                        <SubmitPage
                          showError={showError}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                          handleSubmit={stepHandler}
                          handleBack={handleBack}
                        />
                      </>
                    ) : step === 7 ? (
                      <>
                        <FinalPolicyPreview 
                          formData={formData} 
                          handleBack={handleBack} 
                          handleSubmit={handleSubmit} 
                        />
                        {isLoading && <Spinner />}
                      </>
                    ) : step === 8 ? (
                      <>
                        <FinalSubmissionPage 
                          formData={formData} 
                          handleBack={handleBack} 
                          handleSubmit={handleSubmit} 
                          studentId={studentId}
                          applicationId={applicationId}
                          registerStudent={registerStudent}
                        />
                        {isLoading && <Spinner />}
                      </>
                    ) : step === 9 ? (
                      <SuccessPage formData={formData} />
                    ) : null}
                  </div>
                ) :
                  null
      }
      <ToastContainer />
    </div>
  );
}

export default AdmissionFormPage;
